import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import SydButton from '../../commonDesign/Button'
import BlueprintExportModal from './BlueprintExportModal'

function BlueprintExportButton ({
  blueprintCode,
  config,
  purposeCode,
  parameters,
  filters,
  subordinatePredicates,
  sortBy,
  sortDirection
}) {
  const [open, setOpen] = useState(false)
  const handleClose = useCallback(() => setOpen(false), [])

  if (!config?.export?.enabled) return null

  return (
    <>
      <SydButton
        onClick={() => setOpen(true)}
        variant='outline'
        size='xs'
        icon='download'
      >
        Export
      </SydButton>
      <BlueprintExportModal
        open={open}
        onClose={handleClose}
        blueprintCode={blueprintCode}
        purposeCode={purposeCode}
        parameters={parameters}
        filters={filters}
        subordinatePredicates={subordinatePredicates}
        sortBy={sortBy}
        sortDirection={sortDirection}
        exportConfig={config.export}
      />
    </>
  )
}

BlueprintExportButton.propTypes = {
  blueprintCode: PropTypes.string.isRequired,
  config: PropTypes.shape({
    export: PropTypes.shape({
      enabled: PropTypes.bool,
      formats: PropTypes.arrayOf(PropTypes.string),
      defaultFileName: PropTypes.string
    })
  }).isRequired,
  purposeCode: PropTypes.string.isRequired,
  parameters: PropTypes.object,
  filters: PropTypes.array,
  subordinatePredicates: PropTypes.array,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string
}

export default BlueprintExportButton
